import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const instrucciones = (url, clave) => `Conecta los formularios de la web con mi app de gestión de pacientes. Mantén el envío por correo que ya existe y añade este envío además.

Cada vez que alguien envíe el formulario de contacto o termine cualquier cuestionario de /cuestionarios, el BACKEND de la web (nunca el navegador) debe hacer:

POST ${url}
Cabeceras: Content-Type: application/json, X-Clave-Web: <valor de la variable de entorno GESTION_CLAVE_WEB>
Cuerpo JSON:
{
  "tipo": "contacto" o "cuestionario",
  "nombre": "nombre y apellidos del PACIENTE (el niño si es infantil)",
  "telefono": "", "email": "", "fecha_nacimiento": "AAAA-MM-DD",
  "tutor": "padre/madre/tutor si lo hay", "motivo_consulta": "", "colegio": "", "curso": "",
  "centro": "MADRID o ALCOBENDAS si se sabe", "como_nos_conocio": "",
  "asunto": "", "mensaje": "",
  "cuestionario": { "codigo": "juvenil_7_20", "titulo": "Anamnesis Juvenil (7-20 años)",
    "respuestas": [ { "seccion": "...", "pregunta": "texto de la pregunta", "respuesta": "texto de la respuesta" } ] }
}

Guarda la clave en la variable de entorno GESTION_CLAVE_WEB = ${clave || "<clave>"}
Si el envío falla, no bloquees al usuario: guarda el envío y reinténtalo más tarde.
Incluye TODAS las preguntas y respuestas del cuestionario, incluidas las de protección de datos y consentimiento de imagen.
Además, adjunta el PDF de consentimiento que genera la web para ese envío (el mismo de /admin/submissions/{id}/consent-pdf), en base64, en el campo "cuestionario.consentimiento_pdf_base64". Hazlo también en el botón "Reenviar a la app de gestión".
Después, reenvía UNA VEZ todos los cuestionarios ya enviados (con su PDF de consentimiento): la app reconoce los que ya tiene y no los duplica, solo les añade el PDF.
Cuando esté hecho, haz un envío de prueba con nombre "PRUEBA WEB" y dime qué respondió la app.`;

export const WebConexion = () => {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/web-intake/config").then((r) => setC(r.data));
  }, []);
  const generar = async () => {
    if (c?.clave && !window.confirm("¿Generar una clave nueva? La web dejará de conectar hasta que pongas la nueva clave allí.")) return;
    const { data } = await api.post("/web-intake/clave");
    setC(data);
    toast.success("Clave generada");
  };
  const copiar = () => {
    navigator.clipboard.writeText(instrucciones(c.url, c.clave));
    toast.success("Instrucciones copiadas");
  };
  if (!c) return null;
  return (
    <div className="space-y-2 text-sm" data-testid="web-conexion">
      <ol className="list-decimal pl-5 text-slate-600 space-y-0.5" data-testid="web-pasos">
        <li>Hazlo desde la app publicada (gestion.saludyvision.es), no desde la vista previa.</li>
        <li>Pulsa <b>Generar clave</b> y luego <b>Copiar instrucciones para la web</b>.</li>
        <li>Abre en Emergent el proyecto de la web saludyvision.es, pega las instrucciones en su chat y, cuando termine, publícalo (Re-deploy).</li>
        <li>Rellena un cuestionario de prueba en la web: aparecerá en <b>Solicitudes web</b>. Después borra esa ficha de prueba.</li>
      </ol>
      <div className="flex flex-wrap gap-2">
        <button onClick={generar} data-testid="web-clave-btn" className="rounded-md bg-[#1E3A8A] text-white px-3 py-1.5">{c.clave ? "Generar clave nueva" : "Generar clave"}</button>
        {c.clave && <button onClick={copiar} data-testid="web-copiar-btn" className="rounded-md border border-slate-300 px-3 py-1.5">Copiar instrucciones para la web</button>}
      </div>
      {c.clave && <div className="text-xs text-slate-500" data-testid="web-clave-ok">Clave activa: empieza por <b data-testid="web-clave-inicio">{c.clave.slice(0, 3)}</b> y acaba en <b data-testid="web-clave-fin">{c.clave.slice(-2)}</b>. Dirección: <span className="font-[JetBrains_Mono]">{c.url}</span></div>}
    </div>
  );
};
